import { iframeResizer } from 'iframe-resizer';

export const autoResizeHeight = (iframeId: string) => {
    iframeResizer({ checkOrigin: false }, document.querySelector(iframeId));
};

(window as any).autoResizeHeight = autoResizeHeight;
